import { Stethoscope } from "lucide-react";
import { DISCLOSURES } from "@/config/site";
import { SERVICES } from "@/config/services";
import { useSeo } from "@/lib/seo";
import { PageHero } from "@/components/common/PageHero";
import { Section, SectionHeading } from "@/components/common/Section";
import { ServiceCard } from "@/components/common/ServiceCard";
import { Reveal, StaggerGroup, StaggerItem } from "@/components/common/Reveal";
import { EmptyState, IntegrationPlaceholder } from "@/components/common/EmptyState";
import { CTABand } from "@/components/common/CTABand";
import { LinkButton } from "@/components/common/LinkButton";
import { IMAGES } from "@/config/site";

export default function Services() {
  useSeo({
    title: "Services | Legacy Spa — Massage Therapy in Houston",
    description:
      "Explore Legacy Spa massage services in Greater Houston: in-suite massage, mobile massage, corporate chair and table massage, and corporate wellness programs.",
    path: "/services",
  });

  return (
    <>
      <PageHero
        eyebrow="Services"
        titleLines={["Professional massage,", "your way."]}
        lead="A flexible service directory for individuals, mobile clients and organizations across Greater Houston."
        image={IMAGES.massageRoom}
        imageAlt="A calm, clean massage treatment room."
      />

      <Section className="bg-legacy-charcoal">
        <SectionHeading
          eyebrow="Service Directory"
          title="Confirmed service categories."
          as="h2"
          lead={DISCLOSURES.booking}
        />
        <StaggerGroup className="mt-14 grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {SERVICES.map((s) => (
            <StaggerItem key={s.id}>
              <ServiceCard service={s} />
            </StaggerItem>
          ))}
        </StaggerGroup>

        <div className="mt-10">
          <Reveal>
            <IntegrationPlaceholder
              title="Vagaro Booking"
              description="Service details, availability and pricing are managed and confirmed through Vagaro. Booking buttons open the Legacy Spa Vagaro page."
            />
          </Reveal>
        </div>
      </Section>

      {/* Future: Medical Massage */}
      <Section className="bg-[#12201d]">
        <SectionHeading eyebrow="Future Services" title="Medical massage." as="h2" />
        <div className="mt-10">
          <Reveal>
            <EmptyState
              icon={Stethoscope}
              title="Planned for a future phase"
              description={DISCLOSURES.medicalFuture}
            />
          </Reveal>
        </div>
      </Section>

      <CTABand
        eyebrow="Book with confidence"
        title="Reserve your session on Vagaro."
        lead="Pricing, duration and availability are confirmed at booking."
        secondary={
          <LinkButton to="/mobile-massage" variant="outline" size="lg" testId="services-mobile-btn">
            Explore Mobile Massage
          </LinkButton>
        }
      />
    </>
  );
}
